const ba_api = process.env.BA_API;

export default {
	api: ba_api,
	services: {
		companies: ba_api + '/companies',
		companyHouse: ba_api + '/companies/companyHouse',
		companyDetails: ba_api + '/companies/getCompanyDetails',
		properties: ba_api + '/properties',
		booking: ba_api + '/booking',
		billing: ba_api + '/billing',
		payments: ba_api + '/payments',
		offers: ba_api + '/offers',
		portals: ba_api + '/portals',
		portalsCustom: ba_api + '/portals-custom',
		gdpr: ba_api + '/gdpr',
		applicants: ba_api + '/applicants',
		owners: ba_api + '/owners',
		website: ba_api + '/wp',
		domains: ba_api + '/domains',
		rest: ba_api + '/v1/admin',
		matching: ba_api + '/matching'
	},
	aws: {
		region: 'eu-west-2',
		bucket: 'em2-stage1',
		identityPoolId: process.env.BA_IDENTITYPOOLID,
		userPoolId: process.env.BA_USERPOOLID,
		userPoolClientId: process.env.BA_USERPOOLCLIENTID
	},
	social: {
		fbAppId: '1914621552188664',
		googleAppId: '446207093208-enjtcbiub6tf3t9o79kofgiaglk9c9u0.apps.googleusercontent.com',
		linkedinId: '78dyng07s6xrbc',
		linkedinIdSecret: 'w104AJpWr4f99wQA'
	}
}



// WEBPACK FOOTER //
// ./src/config.js